import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { CONTENT_STATUS_ARCHIVED } from './archivingConstants.ts';
import ArchivedPageBannerV2ArchivedPageBannerQuery, {
	type ArchivedPageBannerV2ArchivedPageBannerQuery$data,
	type ArchivedPageBannerV2ArchivedPageBannerQuery$variables,
} from './__generated__/ArchivedPageBannerV2ArchivedPageBannerQuery.graphql.ts';
import ArchivedPageBannerV2ArchivedPageBannerContainerQuery, {
	type ArchivedPageBannerV2ArchivedPageBannerContainerQuery$data,
	type ArchivedPageBannerV2ArchivedPageBannerContainerQuery$variables,
} from './__generated__/ArchivedPageBannerV2ArchivedPageBannerContainerQuery.graphql.ts';

export function preloadArchivedPageBannerV2Queries(contentId: string) {
	if (!contentId) {
		return Promise.resolve();
	}

	return query<
		ArchivedPageBannerV2ArchivedPageBannerContainerQuery$data,
		ArchivedPageBannerV2ArchivedPageBannerContainerQuery$variables
	>({
		query: ArchivedPageBannerV2ArchivedPageBannerContainerQuery,
		variables: { contentId },
	}).then(({ data }): Promise<any> | void => {
		const contentStatus = data?.content?.nodes?.[0]?.status;
		const isContentArchived = contentStatus === CONTENT_STATUS_ARCHIVED;

		if (isContentArchived) {
			return query<
				ArchivedPageBannerV2ArchivedPageBannerQuery$data,
				ArchivedPageBannerV2ArchivedPageBannerQuery$variables
			>({
				query: ArchivedPageBannerV2ArchivedPageBannerQuery,
				variables: { contentId },
			});
		}
		return Promise.resolve();
	});
}
